import { SPECIAL_DATE_RANGES } from '/src/features/_global/constants';

export const WEB_ANALYTIC_METRICS = {
  UNIQUE_VISITORS: 'uniqueVisitors',
  PAGE_VIEWS: 'pageViews',
  AVG_SESSION_DURATION: 'avgSessionDuration',
  SESSIONS: 'sessions',
  BOUNCE_RATE: 'bounceRate',
};

export const DEFAULT_DATE_RANGE = { special: SPECIAL_DATE_RANGES.LAST_30_DAYS };
export const DIMENSIONS = ['DATE', 'COUNTRY', 'BROWSER'];
